var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('Header',{ref:"child",staticClass:"fixhead"}),_c('div',{on:{"mouseover":_vm.sendData}},[_c('Content',{staticStyle:{"padding-top":"138px"}}),_c('Footer',{staticStyle:{"margin-top":"60px"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }